// import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
import palette from './palette';

// const breakpoints = createBreakpoints({});

export default {
    h1: {
        color: palette.text.primary,
        fontWeight: 400,
        fontSize: '24px',
        lineHeight: 1,

        // [breakpoints.up('md')]: {
        //     fontSize: '36px'
        // }
    },
    h2: {
        color: palette.text.primary,
        fontWeight: 400,
        fontSize: '24px',
        lineHeight: 1,

        // [breakpoints.up('md')]: {
        //     fontSize: '26px'
        // }
    },
    h3: {
        color: palette.text.primary,
        fontWeight: 400,
        fontSize: '20px',
        lineHeight: 1
    },
    h4: {
        color: palette.text.primary,
        fontWeight: 500,
        fontSize: '20px',
        letterSpacing: '-0.06px',
        lineHeight: '24px'
    },
    h5: {
        color: palette.text.primary,
        fontWeight: 500,
        fontSize: '16px',
        letterSpacing: '-0.05px',
        lineHeight: '20px'
    },
    h6: {
        color: palette.text.primary,
        fontWeight: 500,
        fontSize: '14px',
        letterSpacing: '-0.05px',
        lineHeight: '20px'
    },
    subtitle1: {
        color: palette.text.primary,
        fontSize: '16px',
        letterSpacing: '-0.05px',
        fontWeight: 300,
        lineHeight: '1.5em'
    },
    subtitle2: {
        color: palette.text.secondary,
        fontWeight: 400,
        fontSize: '14px',
        letterSpacing: '-0.05px',
        lineHeight: '21px'
    },
    body1: {
        color: palette.text.primary,
        fontSize: '14px',
        letterSpacing: '-0.05px',
        lineHeight: '21px'
    },
    body2: {
        color: palette.text.secondary,
        fontSize: '12px',
        letterSpacing: '-0.04px',
        lineHeight: '18px'
    },
    button: {
        color: palette.text.primary,
        fontSize: '14px'
    },
    caption: {
        color: palette.text.secondary,
        fontSize: '11px',
        letterSpacing: '0.33px',
        lineHeight: '13px'
    },
    overline: {
        color: palette.text.secondary,
        fontSize: '11px',
        fontWeight: 500,
        letterSpacing: '0.33px',
        lineHeight: '13px',
        textTransform: 'uppercase'
    }
};
